module.exports = __webpack_public_path__ + "static/media/menu_home_hoverActive.1e78972a.svg";